import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconChevronLeft = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M42.138 1.943c-.18.045-.424.144-.544.219S35.21 8.47 27.673 16.013c-10.69 10.7-13.747 13.792-13.898 14.067-.342.618-.478 1.166-.478 1.92 0 .755.136 1.302.478 1.92.151.274 3.209 3.37 13.898 14.068 7.537 7.544 13.818 13.784 13.959 13.866.782.458 1.866.29 2.455-.381.392-.447.488-.711.488-1.345 0-.434-.03-.64-.12-.832-.084-.177-4.308-4.445-13.632-13.776L17.313 32l13.51-13.52c9.59-9.597 13.544-13.594 13.625-13.774.145-.32.197-1.007.102-1.356-.098-.364-.43-.84-.76-1.09-.439-.332-1.094-.458-1.652-.317" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconChevronLeft.displayName = 'IconChevronLeft';